export enum OrderDocumentKind {
	Order = 'Order',
}
